module.exports = __webpack_public_path__ + "img/RD02EU.e1fe2ff6.png";